import React, {useState} from 'react';
import {StyleProp, Text, View, ViewStyle} from 'react-native';
import {formsStyles} from '../formStyles';
import {styles} from './styles';

interface dataOption {
  [key: string]: string;
}
const Select = (props: {
  label: string;
  style?: StyleProp<ViewStyle>;
  required?: boolean;
  defaultValue?: string;
  value?: string;
  onChange: (name: string, value: string, fired: boolean) => void;
  name?: string;
  error?: string;
  showError?: boolean;
  disabled?: boolean;
  data: dataOption[];
  selectLabels?: {labelName: string; valueName: string};
}) => {
  const {
    data,
    defaultValue,
    label,
    required,
    name = '',
    onChange,
    value,
    style,
    disabled = false,
    error = '',
    showError = false,
    selectLabels = {labelName: 'label', valueName: 'value'},
  } = props;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [selectedValue, setSelectedValue] = useState<string>(
    value || defaultValue || '',
  );

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handlePickerValueChange = (value: any) => {
    if (!disabled) {
      typeof onChange === 'function' && onChange(name, value, true);
      setSelectedValue(value);
    }
  };

  const selectDataOptions = data.map((element, index) => {
    if (!element) {
      return <option key={index} value={''}></option>;
    }
    return (
      <option key={index} value={element?.[selectLabels.valueName] ?? ''}>
        {element?.[selectLabels.labelName] ?? ''}
      </option>
    );
  });

  return (
    <View style={style}>
      {label ? (
        <Text style={[formsStyles.labelStyle]}>
          {label} {required ? <Text>*</Text> : null}
        </Text>
      ) : null}
      <select
        name={name}
        className="itemSelectPickerStyle"
        style={{
          ...styles.itemPickerStyle,
          borderColor: error && showError ? 'red' : 'rgba(224, 224, 224, 1)',
          outline: 'none',
        }}
        disabled={disabled}
        onChange={e => handlePickerValueChange(e?.target.value)}
        value={value}>
        {selectDataOptions.length ? selectDataOptions : null}
      </select>
      {error && showError ? (
        <Text style={styles.textError}>{error}</Text>
      ) : null}
    </View>
  );
};

export default Select;
